import React from "react";
import classNames from "classnames";

const FooterNav = ({ className, ...props }) => {
	const classes = classNames("footer-nav", className);

	return (
		<nav {...props} className={classes}>
			<ul className="list-reset">
				<li>
					<a href="https://regenman.com"
					   target="_blank"
					   rel="noreferrer" className="text-white">
						Books
					</a>
				</li>
			</ul>
		</nav>
	);
};

export default FooterNav;
